"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Driver_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Driver = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
const Document_1 = require("./Document");
const DriverActivity_1 = require("./DriverActivity");
const KnownLanguage_1 = require("./KnownLanguage");
const Position_1 = require("./Position");
const Score_1 = require("./Score");
let Driver = Driver_1 = class Driver {
    managementNote = "";
    willingToSleepoverCount = 1; // how many times is willing to sleep over
    languages = [];
    town = "";
    address = "";
    position;
    // Functionality removed - field kept only for historical data
    originLocationIds = [];
    willingToRentVehicleTypes = [];
    documents = [];
    driversCompanyUserId;
    hiredAt = new Date();
    hireReason;
    /**
     * This is the date when the driver was approved by support and changed to Active state.
     */
    activeAt;
    declinedAt;
    score = new Score_1.Score();
    activity;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, Driver_1, legacy_enums_1.DriverStatus);
    }
    // id of entity from `locations` collection
    // is set by GCP scheduled function (update-closest-hometown) outside the repository
    closestHometownId;
    // is set by GCP scheduled function (update-closest-hometown) outside the repository
    closestHometown;
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.DriverStatus.Declined:
                return {
                    declinedAt: defined,
                };
            case legacy_enums_1.DriverStatus.Active:
                return {
                    activeAt: defined,
                    declinedAt: undefined,
                };
            case legacy_enums_1.DriverStatus.Hired:
                return {
                    hiredAt: defined,
                    declinedAt: undefined,
                    activeAt: undefined,
                };
            default:
            case legacy_enums_1.DriverStatus.Lead:
                return {
                    hiredAt: undefined,
                    declinedAt: undefined,
                    activeAt: undefined,
                };
        }
    }
    // this field is filled automatically on the backend, so it has to be optional to pass the frontend validation
    hiredByUserId;
    isSuitableForLuxury = false;
    isSuitableForPool = false;
    declinedByCompany = false;
    acquisitionCost;
    canSpeakEnglish = false;
    willingToDoLite = true;
    isTCPDriver = false;
    /**
     * Only applicable to US drivers.
     * Set to null or not set at all for non-US drivers.
     */
    regionId;
    isNotDomesticVATPayer = false;
    hasOfferPriority = false;
    claimingFeeChange;
    rentalReason;
    constructor(init) {
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.Driver = Driver;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "managementNote", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Driver.prototype, "willingToSleepoverCount", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => KnownLanguage_1.KnownLanguage),
    __metadata("design:type", Array)
], Driver.prototype, "languages", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "town", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)({ always: true, message: "Hometown could not be empty" }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "address", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Position_1.Position),
    __metadata("design:type", Position_1.Position)
], Driver.prototype, "position", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Driver.prototype, "originLocationIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], Driver.prototype, "willingToRentVehicleTypes", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Document_1.Document),
    __metadata("design:type", Array)
], Driver.prototype, "documents", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "driversCompanyUserId", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Driver.prototype, "hiredAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "hireReason", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Driver.prototype, "activeAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Driver.prototype, "declinedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Score_1.Score),
    __metadata("design:type", Score_1.Score)
], Driver.prototype, "score", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DriverActivity_1.DriverActivity),
    __metadata("design:type", DriverActivity_1.DriverActivity)
], Driver.prototype, "activity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "closestHometownId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "closestHometown", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "hiredByUserId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Driver.prototype, "isSuitableForLuxury", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Driver.prototype, "isSuitableForPool", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Driver.prototype, "declinedByCompany", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({}),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Driver.prototype, "acquisitionCost", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Driver.prototype, "canSpeakEnglish", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Driver.prototype, "willingToDoLite", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Driver.prototype, "isTCPDriver", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Driver.prototype, "regionId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Driver.prototype, "isNotDomesticVATPayer", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Driver.prototype, "hasOfferPriority", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({}),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Driver.prototype, "claimingFeeChange", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Driver.prototype, "rentalReason", void 0);
exports.Driver = Driver = Driver_1 = __decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:paramtypes", [Object])
], Driver);
//# sourceMappingURL=Driver.js.map